import { render, staticRenderFns } from "./CriteriaTemplateMenu.vue?vue&type=template&id=1551aee4"
import script from "./CriteriaTemplateMenu.vue?vue&type=script&lang=js"
export * from "./CriteriaTemplateMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports